import { FormSubmitMethod } from 'eurogard-forms';
import { IAlarmGroupForm } from 'angular-forms/alarm-group-form/alarm-group.form';
import { inject, Injectable } from '@angular/core';
import { UserControllerUpdateRemoteMethod } from 'open-api-legacy/remote-methods/user-controller-update.remote-method';

@Injectable()
export class UpdateUserActiveTimeMethod implements FormSubmitMethod<IAlarmGroupForm> {

  private readonly userControllerUpdateRemoteMethod = inject(UserControllerUpdateRemoteMethod);

  async call(value: IAlarmGroupForm) {
    await this.userControllerUpdateRemoteMethod.call({
      parameters: {
        uuid: value.uuid,
      },
      requestBody: {
        updateMap: {
          activeTime: JSON.stringify(value.timeslots)
        }
      },
    });
  }

}
